import ReactDOM from "react-dom";
import React from "react";
import { Provider } from "react-redux";
import { applyMiddleware, combineReducers, createStore } from "redux";
import thunk from "redux-thunk";
import reducers from "./redux/reducers";
import { SearchLink } from "Components/SearchField";
import { HamburgerButton } from "Components/BurgerButton/HamburgerButton";
import BasePage from "Pages/BasePage";
import { LanguageBox, LanguageLink } from "Components/LanguageBox/";
import { SearchField } from "Components/SearchField";
import SearchPage from "Pages/SearchPage";
import { AppThemeContextProviderWrapper } from "Helpers/ThemeHelper";
import { ThemeProvider } from "styled-components";
import ReduxQuerySync from "redux-query-sync";

const reducer = combineReducers({
	...reducers,
});
export const store = createStore(reducer, applyMiddleware(thunk));

export const RenderComponent = (model, element) => {
	const App = () => (
		<AppThemeContextProviderWrapper currentTheme={model.CurrentTheme}>
			{GetComponent(model, element)}
		</AppThemeContextProviderWrapper>
	);
	ReactDOM.render(
		<Provider store={store}>
			<App />
		</Provider>,
		element
	);
};

let GetComponent = (model, element, searchQuery) => {
	return <BasePage model={model} element={element} searchQuery={searchQuery} />;
};

export const RenderSearchPage = (element, model, searchQuery) => {
	const App = () => (
		<AppThemeContextProviderWrapper currentTheme={model.CurrentTheme}>
			{GetComponent(model, element, searchQuery)}
		</AppThemeContextProviderWrapper>
	);

	ReactDOM.render(
		<Provider store={store}>
			<App />
		</Provider>,
		element
	);

	ReduxQuerySync({
		store,
		params: {
			query: {
				selector: (state) => state.search.query,
				action: (value) => ({
					type: "setQuery",
					payload: value,
				}),
			},
		},
		initialTruth: "location",
		replaceState: true,
	});
};


export const RenderListPageWithCategories = (element, model, searchQuery) => {
	const App = () => (
		<AppThemeContextProviderWrapper currentTheme={model.CurrentTheme}>
			{GetComponent(model, element, searchQuery)}
		</AppThemeContextProviderWrapper>
	);

	ReactDOM.render(
		<Provider store={store}>
			<App />
		</Provider>,
		element
	);

	ReduxQuerySync({
		store,
		params: {
			query: {
				selector: (state) => state.search.query,
				action: (value) => ({
					type: "setQuery",
					payload: value,
				}),
			},
		},
		initialTruth: "location",
		replaceState: true,
	});
};
